import * as React from 'react';
function SvgSuccess(props) {
    return (<svg width={30} height={30} {...props}>
      <g fill="none" fillRule="evenodd">
        <circle fill="#4FBE0E" cx={15} cy={15} r={15}/>
        <path d="M19.302 10.781l-6.306 6.302-2.298-2.296a1.003 1.003 0 00-1.417 1.416l3.006 3.004c.392.39 1.026.39 1.417 0l7.015-7.01a1 1 0 00-1.417-1.416z" fill="#FFF" fillRule="nonzero"/>
      </g>
    </svg>);
}
export default SvgSuccess;
